module.exports = __webpack_public_path__ + "img/ZB52_10.758a4aca.jpg";